function devtricker_url_removeFacebookCharacterOnLoad() {
    if (window.location.hash && window.location.hash === '#_=_') {
        if (window.history && history.pushState) {
            window.history.pushState("", document.title, window.location.pathname + window.location.search);
        } else {
            window.location.hash = '';
        }
    }
}